export default __webpack_public_path__ + "static/logos-tiles-bmw-364f7ae14c98eac0b2ce32d8ed70a158.svg";